import { Ouvrage } from '../../1-bibliotheque-prix/data/ServicesData';
import { BenchmarkStats, PriceVerdict } from '../types';
import { parsePrixString } from './priceParsing';

export const computeBenchmarkStats = (ouvrage: Ouvrage): BenchmarkStats => {
  const prices = ouvrage.chantiers.map((c) => {
    const raw = c.prixActualise || c.prixUnitaire;
    return parsePrixString(raw);
  }).filter((p) => p > 0);

  if (prices.length === 0) {
    return {
      ouvrageIntitule: ouvrage.intitule,
      unite: ouvrage.unite,
      min: 0,
      max: 0,
      avg: 0,
      median: 0,
      count: 0,
    };
  }

  prices.sort((a, b) => a - b);
  const sum = prices.reduce((acc, p) => acc + p, 0);
  const mid = Math.floor(prices.length / 2);
  const median =
    prices.length % 2 === 0
      ? (prices[mid - 1] + prices[mid]) / 2
      : prices[mid];

  return {
    ouvrageIntitule: ouvrage.intitule,
    unite: ouvrage.unite,
    min: prices[0],
    max: prices[prices.length - 1],
    avg: sum / prices.length,
    median,
    count: prices.length,
  };
};

export const getPriceVerdict = (
  devisPrice: number,
  stats: BenchmarkStats
): PriceVerdict => {
  if (stats.count === 0) return 'no-data';
  if (devisPrice <= stats.avg * 1.05) return 'good';
  if (devisPrice <= stats.avg * 1.20) return 'warning';
  return 'danger';
};

export const computeEcart = (
  devisPrice: number,
  avgBenchmark: number
): number => {
  if (avgBenchmark === 0) return 0;
  return ((devisPrice - avgBenchmark) / avgBenchmark) * 100;
};
